import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PasswordService } from '../services/password.service';
import { CountryList, ErrCode } from 'src/app/shared/models';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/api.service';
import { DropdownItems } from '@material-library';
import { LoggerService } from 'src/app/core/logger.service';
import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { BlendService } from 'src/app/shared/services/blend.service';
  
interface RegisterForm {
  email: FormControl<string>;
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
  term: FormControl<string>;
  terms: FormControl<boolean>;
}


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit{
  
  protected form: FormGroup<RegisterForm>;
  protected spinner = false;
  protected submitted = false;
  protected errCode: ErrCode;
  protected password: String;
  protected confirmPassword: String;
  protected termList: DropdownItems[] = [];
  protected showTerm: boolean = false;
  protected upgradelink: string = '';

  constructor(
    private fb: FormBuilder,
    private passwordService: PasswordService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private log: LoggerService,
    private cookieService: CookieService,
    private authService: AuthService,
    private blendService: BlendService
  ) {
    this.termList = [{
      value: 'month',
      name: 'Monthly'
    }, {
      value: 'year',
      name: 'Yearly'
    }];
  }
  
  ngOnInit(): void {
    this.upgradelink = window.location.href.replace('/register', '/settings/upgrade-plan');
    const term = this.route.snapshot?.queryParams?.term || '';
    if(term !== 'month' && term !== 'year') {
      this.showTerm = true;
    }
    this.form = this.fb.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.email,
      ])],
      password: ['', Validators.compose([
        Validators.required,
        (control) => !this.passwordService.isPasswordStrong(control.value) ? { password: true } : null,
      ])],
      confirmPassword: ['', Validators.required],
      term: [term, Validators.required],
      terms: [false, Validators.requiredTrue]
    });

    this.form.controls.email.valueChanges.subscribe(value => {
      this.form.controls.email.setValue(value?.trim(), { emitEvent: false });
    });

    this.blendService.trackUnauthPageview();
  }

  protected getErrorMessage = (name: keyof RegisterForm) => {
    if (!this.form.controls[name].touched) return;

    if (this.form.controls[name].hasError('required')) {
      return 'This field is required';
    } else if (name == 'email' && this.form.controls.email.hasError('email')) {
        return 'Please enter a valid email address';
    } else if (name == 'password') {
      if (this.form.controls[name].hasError('password')) {
        return 'Enter a password following the requirements';
      }
    }
    else if (name == 'confirmPassword') {
      if (this.submitted && this.form.controls.confirmPassword.value !== this.form.controls.password.value) {
        return 'Passwords do not match';
      }
    }
  }

  protected onInputChange = () => {
    this.submitted = false;
  }

  protected submit = async () => {
    this.submitted = true;
    if (this.form.controls.confirmPassword.value !== this.form.controls.password.value) {
      return;
    }
    this.authService.logout();
    const country = this.route.snapshot?.queryParams?.country || '';
    if (this.form.valid) {
      this.spinner = true;
      const payload = {
        email: this.form.value.email?.trim?.(),
        country: CountryList[country] ? country : '',
        period_unit: this.form.value.term,
        item_id: this.route.snapshot?.queryParams?.item_id,
        coupon_id: this.route.snapshot?.queryParams?.coupon_id,
        qty: this.route.snapshot?.queryParams?.qty,
      }
      try {
        this.cookieService.set('pwd', this.form.value.password);
        const result = await this.apiService.execute('createnewusercheckout', payload) as any;
        window.location.href = result.chargebee_checkout_url;
      } catch (ex) {
        this.log.error(ex);
        this.errCode = ErrCode.fromException(ex);
        this.spinner = false;
      }
    }
  }

}
